import React from 'react';
import { Helmet } from 'react-helmet';

export interface SEOBoxProps {
  title: string;
  description: string;
  url?: string;
  ogType?: 'website' | 'article' | 'profile';
  ogImage?: string;
  twitterHandle?: string;
  children?: React.ReactNode;
}

export function SEOBox({
  title,
  description,
  url = 'https://www.appsaude.ia.br/',
  ogType = 'website',
  ogImage = 'https://www.appsaude.ia.br/images/capa.jpeg',
  twitterHandle = '@appsaude',
  children,
}: SEOBoxProps) {
  return (
    <Helmet>
      {/* Padrão */}
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={url} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={twitterHandle} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Permite que componentes filhos adicionem mais tags <meta> ou <link> ou <script> do Helmet */}
      {children}
    </Helmet>
  );
}
